/**
 * 给定一个数num，求集合[0, num - 1]全部子集
 * @param num
 * @returns
 */
export function getCombinations(num: number) {
  const arr = Array.from({ length: num }, (_, index) => index);
  const res: number[][] = [];
  const path: number[] = [];

  function dfs(i: number) {
    if (i === num) {
      if (path.length > 0) {
        res.push(path.slice());
      }
      return;
    }

    // 不选
    dfs(i + 1);

    // 选
    path.push(arr[i]);
    dfs(i + 1);
    path.pop();
  }

  dfs(0);
  return res;
}

export function excludeSubArray<T = unknown>(subArray: Array<T>, fullArray: Array<T>): Array<T> {
  const exclude = new Set(fullArray);
  subArray.forEach(el => {
    if (exclude.has(el)) {
      exclude.delete(el);
    }
  });
  return Array.from(exclude);
}
